import { useTheme } from 'contexts/ThemeContext';
import React from 'react';
import { Image, TouchableOpacity, View, Text } from 'react-native';
import styleSheet from './styles'

export interface CalendarArrowsViewProps {
    onPressLeft: () => void;
    onPressRight: () => void;
}

const CalendarArrowsView = (props: CalendarArrowsViewProps) => {
    const theme = useTheme()
    const styles = styleSheet(theme);

    return (
        <View style={styles.container}>
            <TouchableOpacity onPress={() => props.onPressLeft()}>
                <Image source={theme.images.arrowLeft}></Image>
            </TouchableOpacity>
            <TouchableOpacity onPress={() => props.onPressRight()}>
                <Image source={theme.images.arrowRight}></Image>
            </TouchableOpacity>
        </View>
    )
};

export default CalendarArrowsView;
